<template>
    <div class="itempage" style="background: #fff">
        <el-card style="position: relative; padding-bottom: 10px">
            <div style="font-size: 16px">
                <b>{{ $t("message.title.workflow") }}: </b>
            </div>
        </el-card>

        <!-- tab切换 -->
        <div class="content">
            <ul class="content-title">
                <li @click="tabClick(item, index)" :class="{ active: index == num }" v-for="(item, index) in tab_all_id"
                    :key="index">
                    {{ item.name }}
                </li>
            </ul>
            <div style="height: 6px; background: #ebebeb"></div>
            <div class="tab1" v-if="tab1_show">
                <div style="height: 30px">
                    <el-button type="primary" size="mini" style="float: right; margin-right: 10px; margin-top: 10px"
                        @click="editInfo" v-if="created_1">{{ $t("message.button.edit") }}</el-button>
                    <el-button type="primary" size="mini" style="float: right; margin-right: 10px; margin-top: 10px"
                        @click="gotoWorkflowList" v-if="created_1">{{ $t("message.button.return") }}
                    </el-button>
                    <el-button size="mini" style="float: right; margin-right: 10px; margin-top: 10px" @click="closeInfo"
                        v-if="!created_1">{{ $t("message.button.cancel") }}</el-button>
                    <el-button type="success" size="mini" style="float: right; margin-right: 10px; margin-top: 10px"
                        @click="submitForm" v-if="!created_1">{{ $t("message.button.save") }}</el-button>
                </div>

                <ul v-if="created_1" style="position: relative; overflow: hidden; list-style: none; width: 100%">
                    <li v-for="item in tab1ViewData" style="width: 100%" :key="item.index">
                        <div class="table-list">
                            <span class="list-key-1">{{ item.name }}</span>
                            <span style="display: inline-block; margin: 0 6px">:</span>
                            <span class="list-val" :title="item.val.val">{{ item.val }}</span>
                        </div>
                    </li>
                </ul>
                <el-form v-else :model="editForm" ref="ruleForm" label-width="200px" class="demo-ruleForm" size="small">
                    <el-form-item :label="$t('message.table.name')" prop="name" :rules="nameRule">
                        <el-input v-model="editForm.name" :style="input_width"></el-input>
                    </el-form-item>

                    <el-form-item :label="$t('message.table.des')" this>
                        <el-input v-model="editForm.description" :style="input_width"></el-input>
                    </el-form-item>

                    <el-form-item :label="$t('message.table.status')">
                        <el-select v-model="editForm.enabled" :placeholder="$t('message.placeholder.select')" size="small"
                            :style="input_width">
                            <el-option :label="$t('message.table.enabled')" value="1"></el-option>
                            <el-option :label="$t('message.table.disabled')" value="0"></el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item>
                        <el-button @click="resetForm">{{
                            $t("message.button.reset")
                        }}</el-button>
                    </el-form-item>
                </el-form>
            </div>

            <div class="tab2" v-if="tab2_show" style="margin-top: 20px">
                <el-button class="btn btn1" icon="el-icon-circle-plus-outline" @click="addNewStatus"
                    :disabled="!editAble">{{ $t("message.button.add") }}
                </el-button>
                <el-button class="btn btn3" icon="el-icon-sort" :disabled="!editAble" @click="sortTablePage">{{
                    $t("message.button.order") }}
                </el-button>

                <div style="padding: 20px">
                    <vxe-grid ref="xGrid" v-bind="gridOptions" @edit-disabled="editDisabledEvent"
                        @cell-dblclick="checkInfo">
                        <template v-slot:operate="{ row }">
                            <vxe-button icon="el-icon-delete" :title="$t('message.button.delete')" circle
                                :disabled="!editAble" @click="removeRowEvent(row)">
                            </vxe-button>
                        </template>
                    </vxe-grid>
                </div>
                <el-dialog :visible.sync="workflowStatusShow" v-if="workflowStatusShow" @closed="statusEditClose">
                    <span v-if="!addStatus_Show" style="position: absolute; left: 30px; top: 30px">{{
                        $t("message.title.addForStatus") }}</span>

                    <div style="height: 40px">
                        <el-button @click="cancel" size="mini" style="float: right; margin-right: 10px; margin-top: 10px">{{
                            $t("message.button.cancel") }}</el-button>
                        <el-button size="mini" style="float: right; margin-right: 10px; margin-top: 10px"
                            @click="resetPageInfo">
                            {{ $t("message.button.reset") }}
                        </el-button>
                        <el-button v-if="addBtn_Show" type="success" size="mini"
                            style="float: right; margin-right: 10px; margin-top: 10px"
                            @click="saveAddNewStatus('ruleForm')">
                            {{ $t("message.button.add") }}
                        </el-button>
                        <el-button v-else type="success" size="mini"
                            style="float: right; margin-right: 10px; margin-top: 10px" @click="submitPageForm('ruleForm')">
                            {{ $t("message.button.save") }}
                        </el-button>
                    </div>
                    <el-form ref="ruleForm" style="margin-top: 20px" label-width="150px" size="small">
                        <el-form-item :label="$t('message.table.name')" prop="name">
                            <el-input v-model="wfData_edit.name" :disabled="hasUsed" :style="input_width"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('message.table.type')" style="width:100%">
                            <el-select :disabled="hasUsed" v-model="wfData_edit.statusType"
                                :placeholder="$t('message.placeholder.select')" style="width:100%">
                                <el-option :label="$t('message.workflowType.Pending')" :value="0" :disabled="pendingEdit">
                                </el-option>
                                <el-option :label="$t('message.workflowType.Submit')" :value="1"
                                    :disabled="statusEdit"></el-option>
                                <el-option :label="$t('message.workflowType.Review')" :value="2"
                                    :disabled="statusEdit"></el-option>
                                <el-option :label="$t('message.workflowType.Released')" :value="3"
                                    :disabled="statusEdit"></el-option>
                                <el-option :label="$t('message.workflowType.Complete')" :value="4">

                                </el-option>
                                <el-option :label="$t('message.workflowType.Cancel')" :value="5"
                                    :disabled="statusEdit"></el-option>
                                <el-option :label="$t('message.workflowType.Hold')" :value="6"
                                    :disabled="statusEdit"></el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item :label="$t('message.table.order')" v-if="addStatus_Show">
                            <el-input v-model="wfData_edit.statusOrder" disabled :style="input_width"></el-input>
                        </el-form-item>

                        <el-form-item :label="$t('message.title.manualNextStatus')" v-if="addStatus_Show">
                            <el-dialog width="66%" title="NextStatuses" :visible.sync="innerVisible" append-to-body>
                                <el-transfer v-model="checked" :data="transferData" @change="getObject" :key="statusId"
                                    :titles="tableName">
                                </el-transfer>
                            </el-dialog>
                            <ListData :listData="nextStatus" @click="innerD" :style="input_width"></ListData>
                        </el-form-item>

                        <el-form-item :label="$t('message.table.ifReject')" v-if="addStatus_Show && statusType == 2"
                            style="width:100%">
                            <el-select clearable v-model="rejName" :placeholder="$t('message.placeholder.select')"
                                @change="rejChange" style="width:100%">
                                <el-option v-for="o in transferDataRej" :key="o.key" :label="o.label" :value="o.key">
                                </el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item :label="$t('message.table.approver')"
                            v-if="addStatus_Show && (statusType == 2 || statusType == 3)">
                            <span class="list-val" style="float: left; width: 60%">
                                <el-select size="small" style="width: 96%" v-model="approvers" multiple filterable remote
                                    @change="change" :placeholder="$t('message.placeholder.input')"
                                    :remote-method="remoteMethod" :loading="loading">
                                    <el-option v-for="item in options" :key="item.value" :label="item.label"
                                        :value="item.value" :disabled="item.disabled">
                                    </el-option>
                                </el-select>
                            </span>
                            <el-button type="primary" style="float: left" size="small" @click="openSearchApproverWindow">{{ $t("message.button.search") }}</el-button>
                            <el-checkbox style="margin-left: 10px" v-model="isPreemptive">{{ $t("message.title.isPreemptive") }}</el-checkbox>
                        </el-form-item>
                        <el-form-item :label="$t('message.table.observer')"
                            v-if="addStatus_Show && (statusType == 2 || statusType == 3)">
                            <span class="list-val" style="float: left; width: 60%">
                                <el-select style="width: 96%" size="small" v-model="observers" multiple filterable remote
                                    :placeholder="$t('message.placeholder.input')" :remote-method="remoteMethod2"
                                    :loading="loading" @change="change2">
                                    <el-option v-for="item in options2" :key="item.value" :label="item.label"
                                        :value="item.value" :disabled="item.disabled">
                                    </el-option>
                                </el-select>
                            </span>
                            <el-button type="primary" style="float: left" size="small"
                                @click="searchObserverVisible = true">{{ $t("message.button.search") }}</el-button>
                        </el-form-item>
                        <el-form-item label="自动升级" v-if="addStatus_Show && (statusType == 2 || statusType == 3)">
                            <span class="list-val" style="float: left; width: 100%; ">
                                <el-select v-model="wfData_edit.autoPromote" :placeholder="$t('message.placeholder.select')"
                                    size="small" style="width:100%">
                                    <el-option v-for="item in selectList" :label="item.label" :value="item.key"
                                        :key="item.key"></el-option>
                                </el-select>
                            </span>
                        </el-form-item>
                        <el-form-item label="推关通知人" v-if="addStatus_Show && (statusType == 2 || statusType == 3)">
                            <span class="list-val" style="float: left; width: 100%;">
                                <el-select v-model="wfData_edit.noticeTo" clearable multiple
                                    :placeholder="$t('message.placeholder.select')" size="small" style="width:100%">
                                    <el-option v-for="item in noticeUserList" :label="item.label" :value="item.key"
                                        :key="item.key"></el-option>
                                </el-select>
                            </span>
                        </el-form-item>

                        <el-dialog width="50%" :title="$t('message.title.searchUser')" v-if="searchApproverVisible"
                            :visible.sync="searchApproverVisible" append-to-body>
                            <searchAddUsers :userGroupLists1="userGroupLists" @listDbClick="addApprover"></searchAddUsers>
                        </el-dialog>

                        <el-dialog width="50%" :title="$t('message.title.searchUser')" v-if="searchObserverVisible"
                            :visible.sync="searchObserverVisible" append-to-body>
                            <searchAddUsers :userGroupLists1="userGroupLists" @listDbClick="addObserver"></searchAddUsers>
                        </el-dialog>
                    </el-form>
                </el-dialog>
            </div>

            <el-dialog :title="$t('message.table.listOrder')" :visible.sync="dialogSortTable">
                <div class="sortLists">
                    <div class="sortList" style="border: none; color: #606266; font-weight: bold; background: #ebebeb">
                        <span style="margin-left: 40px; display: inline-block; width: 40%">{{ $t("message.table.name") }}</span>
                        <span style="display: inline-block; width: 30%">{{ $t("message.table.type") }}</span>
                        <span style="float: right; margin-right: 40px">{{ $t("message.table.order") }}</span>
                    </div>
                </div>
                <div class="sortLists" ref="example">
                    <div class="sortList" v-for="(item, index) in sort_table_val" :key="index">
                        <span style="margin-left: 40px; display: inline-block; width: 40%">{{ item.name }}</span>
                        <span style="display: inline-block; width: 30%">{{ item.statusType }}</span>
                        <span style="float: right; margin-right: 40px">{{ item.statusOrder }}</span>
                    </div>
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="updateSortClose">{{ $t("message.button.cancel") }}</el-button>
                    <el-button type="primary" @click="updateSort">{{ $t("message.button.affirm") }}</el-button>
                </span>
            </el-dialog>
        </div>
    </div>
</template>
<style>
.el-transfer-panel {
    width: 360px !important;
}

.status-type {
    width: 100%;
}

.table-list li {
    overflow: hidden;
}

.table-list .list-key {
    display: inline-block;
    width: 42%;
    text-align: right;
    font-size: 14px;
}

.table-list .list-val {
    display: inline-block;
    width: 52%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    line-height: 18px;
    font-size: 14px;
    position: relative;
    top: 3px;
}

.table-list .list-key-1 {
    display: inline-block;
    width: 18.5%;
    text-align: right;
    font-size: 14px;
    color: #8492a6;
}
</style>
  
<style scoped>
.tab1 {
    padding: 25px 60px;
}

.blue-background-class {
    background: #3ea4f9;
    color: #fff;
}

.sortLists {
    width: 100%;
    border-top: 1px solid #ebebeb;
    border-right: 1px solid #ebebeb;
    border-left: 1px solid #ebebeb;
}

.sortList {
    width: 100%;
    height: 40px;
    border-bottom: 1px solid #ebebeb;
    line-height: 40px;
}

.content-title {
    padding: 0;
    margin: 0;
    overflow: hidden;
    background-size: 100% 100%;
    margin-left: 20px;
    height: 57px;
}

.content-title li {
    float: left;
    padding: 18px 12px 12px 12px;
    font-size: 16px;
    cursor: pointer;
    margin-right: 18px;
}

.content-title li:hover {
    border-bottom: 3px solid #4b92ff;
    color: #4b92ff;
}

.content-title .active {
    border-bottom: 3px solid #4b92ff;
    color: #4b92ff;
}
</style>
  
<script>
import ListData from "./infoShow/listData";
import searchAddUsers from "@/components/searchAddUsers.vue"; //引进addUsers window
import axios from "axios";
import Sortable from "sortablejs";
export default {
    name: "projectWorkflowInfo",
    data() {
        return {
            isPreemptive: false,
            nameRule: [{ required: true, message: this.$t("message.warning.name") }],
            tableName: [
                this.$t("message.transform.choices"),
                this.$t("message.transform.selected"),
            ],
            userGroupLists: "",
            searchApproverVisible: false,
            searchObserverVisible: false,
            options: [],
            options2: [],
            approvers: [],
            observers: [],
            list: [],
            hasUsed: false,
            editAble: false,
            value: "",
            //
            wfId: [],
            wfData_edit: [],
            wfData_edit_old: [],
            wfChoose: [],
            wfSelected: [],
            pendingEdit: true,
            completedEdit: true,
            statusEdit: false,
            addBtn_Show: false,
            addStatus_Show: true,
            statusId: "",
            statusType: Number,
            statusAreaH: Number,
            rejName: "",
            rejKey: "",
            innerVisible: false,

            //nextStatus
            nextStatus: [],
            entryField: [],
            exitField: [],
            allNames: [],

            //NextStatus内层弹出框数据
            tableName: [], //数据表名
            transferData: [], //Transfer 的数据源	array[{ key, label, disabled }]
            transferDataRej: [], //Transfer 的数据源	array[{ key, label, disabled }]
            checked: [], //穿梭框绑定的数据，选定到右侧框中的数据项的value组成的数组

            //Entry 内层数据
            clsId: [],
            entryData: [],
            checked01: [],
            entryDataList: [],
            //entrySelect,
            //entryResData,

            //Exit
            clsId02: [],
            exitData: [],
            checked02: [],

            ////  数据重置备份
            statusOld: [],
            entryOLd: [],
            exitOld: [],
            options: [],

            input_width: {},
            sort_table_val: [],
            sort_table_val_old: [],
            type_name_arr: [],
            dialogSortTable: false,

            tab1_show: true,
            tab2_show: false,
            gridOptions: {
                keepSource: true,
                resizable: true,
                border: true,
                stripe: true,
                highlightHoverRow: true,
                highlightCurrentRow: true,
                showHeaderOverflow: true,
                showOverflow: true,
                rowId: "id",
                height: "530",
                size: "small",
                classId: [],
                columns: [
                    {
                        field: "name",
                        title: this.$t("message.table.name"),
                        editRender: {
                            name: "$input",
                            props: {
                                placeholder: this.$t("message.palceholder.input"),
                            },
                        },
                    },
                    {
                        field: "statusType",
                        title: this.$t("message.table.status"),
                        editRender: {
                            name: "$select",
                            options: [
                                {
                                    label: this.$t("message.workflowType.Pending"),
                                    value: 0,
                                },
                                {
                                    label: this.$t("message.workflowType.Submit"),
                                    value: 1,
                                },
                                {
                                    label: this.$t("message.workflowType.Review"),
                                    value: 2,
                                },
                                {
                                    label: this.$t("message.workflowType.Released"),
                                    value: 3,
                                },
                                {
                                    label: this.$t("message.workflowType.Complete"),
                                    value: 4,
                                },
                                {
                                    label: this.$t("message.workflowType.Cancel"),
                                    value: 5,
                                },
                                {
                                    label: this.$t("message.workflowType.Hold"),
                                    value: 6,
                                },
                            ],
                        },
                    },
                    {
                        field: "statusOrder",
                        title: this.$t("message.table.order"),
                        editRender: {
                            name: "$input",
                        },
                    },
                    {
                        title: this.$t("message.table.actions"),
                        width: 120,
                        slots: {
                            default: "operate",
                        },
                    },
                ],
                data: [],

                editConfig: {
                    // trigger: 'dblclick',
                    // mode: 'row',
                    showIcon: false,
                    activeMethod: this.activeRowMethod,
                    showStatus: true,
                },
                editRules: {
                    entryValue: [
                        {
                            required: true,
                            message: this.$t("message.warning.name"),
                        },
                        {
                            min: 2,
                            max: 18,
                            message: this.$t("message.warning.length_106"),
                        },
                    ],
                },
                sortConfig: {
                    trigger: "cell",
                },
            },
            old_grid_data: {},
            workflowStatusShow: false,

            editShow: false,
            created_1: true,
            old_data: {},
            editForm: {
                name: "",
                description: "",
                enabled: "1",
            },
            num: 0,
            input_width: {},
            loading: true,

            selectList: [
                { key: 1, label: this.$t("message.table.yes") },
                { key: 0, label: this.$t("message.table.no") },
            ],
            noticeUserList: [
                { key: "1", label: "创建人" },
                { key: "2", label: this.$t("message.table.approver") },
                { key: "3", label: this.$t("message.table.observer") },
            ],

            tab_all_id: [
                {
                    name: this.$t("message.table.baseInfo"),
                },
                {
                    name: this.$t("message.table.status"),
                },
            ],

            tab1ViewData: [
                {
                    name: this.$t("message.table.name"),
                    id: "name",
                    val: "",
                },
                {
                    name: this.$t("message.table.des"),
                    id: "description",
                    val: "",
                },
                {
                    name: this.$t("message.table.status"),
                    id: "enabled",
                    val: "",
                },
            ],
        };
    },
    components: {
        ListData,
        searchAddUsers,
    },
    methods: {
        gotoWorkflowList() {
            //返回显示所有工作流状态窗口
            this.$router.push("/projectWorkflows");
        },
        async updateUsers() {
            this.list = [];
            var loadTableUrl = `/pmdm/admin/user/getApproveUserList?privType=16`;
            const {
                //获取标题
                data: res,
            } = await this.$http.get(loadTableUrl);
            let rows = [...res.object.users];
            this.list = rows.map((i) => ({
                value: i.id,
                label: i.loginId + "(" + i.userName + ")",
                disabled: !i.authTag,
            }));

            let groupRows = [...res.object.userGroups];
            this.userGroupLists = groupRows.map((i) => ({
                id: i.id,
                name: i.loginId + "(" + i.userName + ")",
                disabled: !i.authTag,
            }));
        },
        addApprover(row) {
            //添加
            if (row) {
                console.log(this.approvers.length);
                //console.log(row);
                var isDuplicateVal = false;
                for (var j = 0; j < this.approvers.length; j++) {
                    //console.log(this.approvers[j]);
                    if (row.itemId == this.approvers[j]) {
                        isDuplicateVal = true;
                        break;
                    }
                }
                if (isDuplicateVal) {
                    this.$message.error(this.$t("message.error.addSame"));
                } else {
                    this.searchApproverVisible = false;
                    let user = {};
                    user.value = row.itemId;
                    for (var i = 0; i < this.list.length; i++) {
                        if (this.list[i].value == row.itemId) {
                            user.label = this.list[i].label;
                        }
                    }
                    this.options.push(user);
                    this.approvers.push(row.itemId);
                }
            }
        },
        addObserver(row) {
            //添加
            if (row) {
                console.log(this.observers.length);
                //console.log(row);
                var isDuplicateVal = false;
                for (var j = 0; j < this.observers.length; j++) {
                    if (row.itemId == this.observers[j]) {
                        isDuplicateVal = true;
                        break;
                    }
                }
                if (isDuplicateVal) {
                    this.$message.error(this.$t("message.error.addSame"));
                } else {
                    this.searchObserverVisible = false;
                    let user = {};
                    user.value = row.itemId;
                    for (var i = 0; i < this.list.length; i++) {
                        if (this.list[i].value == row.itemId) {
                            user.label = this.list[i].label;
                        }
                    }
                    this.options2.push(user);
                    this.observers.push(row.itemId);
                }
            }
        },

        openSearchApproverWindow() {
            //console.log(this.approvers);
            this.searchApproverVisible = true;
        },
        change() {
            this.options = [];
        },
        change2() {
            this.options2 = [];
        },
        remoteMethod(query) {
            if (query !== "") {
                this.loading = true;
                setTimeout(() => {
                    this.loading = false;
                    this.options = this.list.filter((item) => {
                        return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
                    });
                }, 200);
            } else {
                this.options = [];
            }
        },
        remoteMethod2(query) {
            if (query !== "") {
                this.loading = true;
                setTimeout(() => {
                    this.loading = false;
                    this.options2 = this.list.filter((item) => {
                        return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
                    });
                }, 200);
            } else {
                this.options2 = [];
            }
        },

        loadTable() {
            this.input_width = this.Global.input_width;
            axios
                .get(
                    "/pmdm/admin/workflow/getAllStatus?workflowId=" +
                    this.$store.state.listId
                )
                .then((res) => {
                    const resData = res.data.object;
                    this.wfId = this.findStatuses(resData);
                    this.gridOptions.data = res.data.object;
                    this.old_grid_data = this.deepClone(res.data.object);
                    this.sort_table_val = this.deepClone(res.data.object);

                    for (var i = 0; i < this.sort_table_val.length; i++) {
                        this.sort_table_val[i].statusType = this.type_name_arr[
                            this.sort_table_val[i].statusType
                        ];
                    }

                    this.sort_table_val_old = this.deepClone(this.sort_table_val);
                })
                .catch((error) => {
                    //console.log(error);
                });
        },
        getAllNames() {
            axios
                .get(
                    "/pmdm/admin/workflow/findItemChangeFileds?workflowId=" +
                    this.$store.state.listId
                )
                .then((res) => {
                    console.log(res.data.object);
                    const allData = res.data.object;
                    this.clsId = res.data.object.clsList;
                    this.clsId02 = res.data.object.clsList;
                    this.entryData = allData.idNamesMap;
                    this.exitData = allData.idNamesMap;

                    this.allNames = this.arrSplit(res.data.object.allFieldsNames);
                });
        },
        resetForm() {
            // this.editForm = {};
            this.editForm.name = "";
            this.editForm.description = "";
            this.editForm.enabled = "0";
            this.isPreemptive = false;
            // this.editForm = this.deepClone(this.old_data);
        },

        getUpdateEvent() {
            var vm = this;
            this.$refs.xGrid.validate(true).then((res) => {
                if (!res) {
                    var xGrid_ = this.$refs.xGrid;
                    let updateRecords = this.$refs.xGrid.getUpdateRecords(); //获取修改的行
                    //console.log(updateRecords);
                    if (updateRecords.length !== 0) {
                        //编辑
                        for (var i = 0; i < updateRecords.length; i++) {
                            delete updateRecords[i].id;
                        }
                        var update = {
                            updateEntry: updateRecords,
                        };
                        axios
                            .post("/pmdm/admin/workflow/updateEntry", update)
                            .then(function (res) {
                                if (res.data.code == 200) {
                                    //console.log(res);
                                }
                            })
                            .catch(function (error) {
                                //console.log(error);
                            });
                    }

                    var insertList = this.$refs.xGrid.getInsertRecords();
                    if (insertList.length !== 0) {
                        for (var i = 0; i < insertList.length; i++) {
                            delete insertList[i].children;
                            delete insertList[i].id;
                        }
                        var insert = {
                            insertEntry: insertList,
                        };
                        axios
                            .post("/pmdm/admin/workflow/saveEntry", insert)
                            .then(function (res) {
                                if (res.data.code == 200) {
                                    //console.log(res);
                                    vm.$message({
                                        type: "success",
                                        message: res.data.message,
                                    });
                                    vm.loadTable();
                                }
                            })
                            .catch(function (error) {
                                //console.log(error);
                            });
                    }
                }
            });
        },
        resetPageInfo() {
            this.exitField = [];
            this.entryField = [];
            this.nextStatus = [];
            this.rejName = "";
            this.transferDataRej = [];
            this.wfData_edit.rejectToStatus = "";
            this.approvers = [];
            this.observers = [];
            this.isPreemptive = false;
        },
        editInfo() {
            this.created_1 = false;
        },
        tabClick(res, index) {
            this.num = index;
            var name_ = res.name;
            //console.log(res);
            var vm = this;
            if (name_ == this.$t("message.table.status")) {
                this.tab2_show = true;
                this.tab1_show = false;
            }
            if (name_ == this.$t("message.table.baseInfo")) {
                this.tab2_show = false;
                this.tab1_show = true;
            }
        },
        findStatuses(arr) {
            let n = [];
            for (let i = 0; i < arr.length; i++) {
                const element = arr[i];
                //console.log(element.statusType);
                n.push(element.statusType);
            }
            return n;
        },
        logoInfo() {
            //console.log(this.$store.state.listId);
            var vm = this;
            this.input_width = this.Global.input_width_small;
            axios
                .get("/pmdm/admin/workflow/getSingleBaseClassList")
                .then((res) => {
                    this.gridOptions.classId = res.data.object.classList;
                    axios
                        .get(
                            "/pmdm/admin/workflow/getWorkflow?id=" + this.$store.state.listId
                        )
                        .then((response) => {
                            if (response.data.code == 200) {
                                var res = response.data.object.workflow;
                                var show_data = vm.tab1ViewData;
                                var edit_data = vm.editForm;
                                show_data[0].val = res.name;
                                edit_data.name = res.name;
                                this.editAble = !res.enabled;
                                show_data[1].val = res.description;
                                edit_data.description = res.description + "";
                                if (res.enabled === 1) {
                                    show_data[2].val = this.$t("message.table.enabled");
                                } else {
                                    show_data[2].val = this.$t("message.table.disabled");
                                }
                                edit_data.enabled = res.enabled + "";
                                edit_data.displayType = res.displayType + "";
                                vm.old_data = vm.deepClone(edit_data);
                            }
                        })
                        .catch();
                })
                .catch(function (error) {
                });
        },
        submitPageForm(formName) {
            this.wfData_edit.name = this.wfData_edit.name.trim();
            if (!this.wfData_edit.name || this.wfData_edit.name.match(/^[ ]*$/)) {
                this.$message.error(this.$t("message.error.name"));
                return false;
            }
            console.log(this.wfData_edit);
            console.log(this.wfData_edit.rejectToStatus);
            if (
                this.wfData_edit.rejectToStatus == null ||
                this.wfData_edit.rejectToStatus == ""
            ) {
                //如果“若拒绝，请设置状态”有值，保存时需要判断“下一状态”是否包含此值
            }
            if (this.isPreemptive == true) {
                if (
                    this.wfData_edit.rejectToStatus == null ||
                    this.wfData_edit.rejectToStatus == ""
                ) {
                    this.$message.error(this.$t("message.error.rejectToStatus"));
                    return false;
                }
            }
            //var obj = this.contrastData(this.wfData_edit_old,this.wfData_edit);
            var obj = this.deepClone(this.wfData_edit);
            console.log(obj);
            obj.noticeTo = obj.noticeTo.join(";");

            let app = this.approvers;
            let obs = this.observers;

            for (var m = 0; m < app.length; m++) {
                for (var n = 0; n < obs.length; n++) {
                    if (app[m] == obs[n]) {
                        this.$message.error(this.MessageInfo.e_203);
                        return false;
                    }
                }
            }

            var approversInRequest = "";
            for (var i = 0; i < app.length; i++) {
                approversInRequest += app[i] + ";";
            }

            var observersInRequest = "";
            for (var i = 0; i < obs.length; i++) {
                observersInRequest += obs[i] + ";";
            }

            obj.approveUser = approversInRequest.slice(
                0,
                approversInRequest.length - 1
            );
            obj.observerUser = observersInRequest.slice(
                0,
                observersInRequest.length - 1
            );
            console.log(this.isPreemptive);
            obj.isPreemptive = this.isPreemptive;
            axios
                .post("/pmdm/admin/workflow/saveWorkflowStatus", obj)
                .then((res) => {
                    //console.log(res);
                    if (res.data.code == 200) {
                        this.$message({
                            message: res.data.message,
                            type: "success",
                        });
                        this.checked = [];
                        this.checked01 = [];
                        this.checked02 = [];
                        this.workflowStatusShow = false;
                        this.loadTable();
                    }
                })
                .catch();
        },

        rejChange(e) {
            this.wfData_edit.rejectToStatus = e;
        },
        statusEditClose() {
            this.checked = [];
            this.checked01 = [];
            this.checked02 = [];
            this.rejName = "";
            this.transferDataRej = [];
            this.isPreemptive = false;
        },
        addNewStatus() {
            //打开无状态页面时
            // console.log(this.pendingEdit);
            if (this.wfId.length == 0) {
                this.statusEdit = true;
                this.pendingEdit = false;
                this.completedEdit = true;
            } else {
                //当打开有状态页面时
                var hasPending = false;
                for (let i = 0; i < this.wfId.length; i++) {
                    if (this.wfId[i] == 0) {
                        hasPending = true;
                    }
                }
                this.pendingEdit = hasPending;
                this.statusEdit = false;
                if (this.wfId.indexOf(4) != -1) {
                    this.completedEdit = true;
                } else {
                    this.completedEdit = false;
                }
            }
            // console.log(this.pendingEdit);
            // console.log(this.wfId);
            this.hasUsed = false;
            //console.log(this.pendingEdit);
            this.workflowStatusShow = true;
            this.addBtn_Show = true;
            this.addStatus_Show = false;
            this.wfData_edit = {};
            this.wfData_edit_old = {};
            this.addNewStatusTitle = this.$t("message.title.add");

            this.exitField = [];
            this.entryField = [];
            this.nextStatus = [];
        },
        cancel() {
            this.workflowStatusShow = false;
        },
        saveAddNewStatus(formName) {
            var obj = this.deepClone(this.wfData_edit);
            obj = Object.assign({ workflowId: this.$store.state.listId }, obj);
            console.log(obj)
            if (obj.statusType == 2) {
                // obj = Object.assign({ autoPromote: 1 }, obj);
                obj.autoPromote = 1
            }

            console.log(obj)
            //console.log(obj);
            axios
                .post("/pmdm/admin/workflow/saveWorkflowStatus", obj)
                .then((res) => {
                    console.log(res);
                    if (res.data.code == 200) {
                        this.$message({
                            message: res.data.message,
                            type: "success",
                        });
                        this.workflowStatusShow = false;
                        this.loadTable();
                    }
                })
                .catch();
        },
        checkInfo(rowInfo) {
            let row = rowInfo.row;
            console.log(row);
            this.statusType = row.statusType;
            this.approvers = [];
            this.observers = [];
            this.options = [];
            this.options2 = [];
            this.workflowStatusShow = true;
            this.addBtn_Show = false;
            this.addStatus_Show = true;
            this.isPreemptive = false;
            console.log(this.isPreemptive);

            this.updateUsers();
            if (row.statusType == 0) {
                this.statusEdit = true;
                this.completedEdit = true;
            } else {
                this.statusEdit = false;
                this.pendingEdit = true;
                if (this.wfId.indexOf(4) != -1) {
                    this.completedEdit = true;
                } else {
                    this.completedEdit = false;
                }
            }
            //console.log(row);
            axios
                .get("/pmdm/admin/workflow/getWorkflowStatusInfo?statusId=" + row.id)
                .then((res) => {
                    //console.log(res);
                    let data = res.data.object;
                    this.hasUsed = !!data.hasUsed;
                    console.log(this.hasUsed);
                    this.statusId = data.workflowStatus.id;
                    data.enabled = data.enabled + "";
                    this.wfData_edit = { ...data.workflowStatus };
                    console.log(this.wfData_edit);
                    this.wfData_edit_old = { ...data.workflowStatus };

                    this.wfData_edit.noticeTo = !this.wfData_edit.noticeTo ? [] : this.wfData_edit.noticeTo.split(";");

                    this.wfChoose = [...data.chooseList];
                    this.wfSelected = [...data.seletedList];
                    this.wfSelected = this.turnArr(this.wfSelected);

                    this.transferData = this.turnArr(this.wfChoose);
                    // console.log(this.wfSelected,1218);
                    // console.log(this.transferData,1219);
                    this.checked = this.wfSelected.map((i) => i.key);

                    for (let i = 0; i < this.wfSelected.length; i++) {
                        const element = this.wfSelected[i];
                        this.transferData.push(element);
                    }

                    this.transferDataRej = this.wfSelected;

                    this.nextStatus = this.wfSelected.map((item) => item.label);
                    //  数据重置备份
                    this.statusOld = this.deepClone(this.nextStatus);
                    this.entryOLd = this.deepClone(this.entryField);
                    this.exitOld = this.deepClone(this.exitField);

                    this.rejKey = data.workflowStatus.rejectToStatus;
                    if (this.rejKey == null) {
                        this.rejName = "";
                    } else {
                        console.log(this.transferData[index]);
                        let index = this.transferData.findIndex(
                            (item) => item.key == this.rejKey
                        );
                        this.rejName = this.transferData[index].label;
                        console.log(this.rejName);
                    }

                    let approveUsers = data.approveUserList;
                    for (let i = 0; i < approveUsers.length; i++) {
                        this.approvers.push(approveUsers[i].id);
                        let obj = {};
                        obj.value = approveUsers[i].id;
                        obj.label =
                            approveUsers[i].loginId + "(" + approveUsers[i].userName + ")";
                        this.options.push(obj);
                    }
                    let observerUsers = data.observerUserList;
                    for (let i = 0; i < observerUsers.length; i++) {
                        this.observers.push(observerUsers[i].id);
                        let obj = {};
                        obj.value = observerUsers[i].id;
                        obj.label =
                            observerUsers[i].loginId + "(" + observerUsers[i].userName + ")";
                        this.options2.push(obj);
                    }

                    this.isPreemptive = !!data.workflowStatus.isPreemptive;
                    console.log(this.isPreemptive);
                })
                .catch();
        },
        removeRowEvent(row) {
            this.$confirm(
                this.$t("message.confirm.deleteList"),
                this.$t("message.tips.tip"),
                {
                    confirmButtonText: this.$t("message.button.affirm"),
                    cancelButtonText: this.$t("message.button.cancel"),
                    type: "warning",
                }
            )
                .then(() => {
                    axios
                        .get("/pmdm/admin/workflow/deleteWorkflowStatus?statusId=" + row.id)
                        .then((res) => {
                            if (res.data.code == 200) {
                                //console.log(res);
                                this.$message({
                                    type: "success",
                                    message: res.data.message,
                                });
                                this.loadTable();
                            }
                        })
                        .catch();
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: this.$t("message.tips.deleteCancel"),
                    });
                });
        },
        innerD(e) {
            this.innerVisible = true;
        },
        getObject() {
            this.wfData_edit.manualNextStatuses = this.checked.join(";");
            let data = this.checked;
            let n = [];
            for (let i = 0; i < data.length; i++) {
                const ele = data[i];
                n.push({
                    key: ele,
                });
            }
            let m = this.findIdName(n, this.transferData);
            this.nextStatus = m.map((item) => item.label);
            this.transferDataRej = m;
        },
        findIdName(a, b) {
            var resultArr = [];
            a.forEach((item) => {
                resultArr.push(b.filter((_item) => _item.key === item.key)[0]);
            });
            return resultArr;
        },
        //将字符串数组转换为{key，}数组
        arrSplit(arr) {
            // console.log(arr);
            if (arr == null) return [];
            let data = [];
            for (let i = 0; i < arr.length; i++) {
                data.push({ key: arr[i].split("=")[0], label: arr[i].split("=")[1] });
            }
            return data;
        },
        //将数组中id和name转化成key和label
        turnArr(arr) {
            let data = arr.map((i) => {
                return {
                    key: i.id,
                    label: i.name,
                };
            });
            return data;
        },

        submitForm() {
            this.editForm.name = this.editForm.name.trim();
            if (!this.editForm.name || this.editForm.name.match(/^[ ]*$/)) {
                this.$message.error(this.$t("message.error.name"));
                return false;
            }
            var obj = {};
            var vm = this;
            for (var key in this.editForm) {
                if (this.editForm[key] !== this.old_data[key]) {
                    obj[key] = this.editForm[key];
                }
            }
            if (JSON.stringify(obj) == "{}") {
                vm.$message({
                    message: "请先进行更改",
                    type: "warning",
                });
            } else {
                obj.id = this.$store.state.listId;
                axios
                    .post("/pmdm/admin/workflow/updateWorkflow", obj)
                    .then((res) => {
                        console.log(res);
                        if (res.data.code == 200) {
                            this.logoInfo();
                            this.created_1 = true;
                            this.$message({ message: res.data.message, type: "success" });
                        } else {
                            this.message.error("保存失败");
                        }
                    })
                    .catch(function (error) {
                        //console.log(error);
                    });
            }
        },
        closeInfo() {
            this.created_1 = true;
            this.editForm = this.deepClone(this.old_data);
            this.isPreemptive = false;
        },
        editDisabledEvent() { },
        noEdit({ row }) { },
        srotTable() {
            var vm = this;
            var el = this.$refs["example"];
            console.log(el);
            //设置配置
            var ops = {
                animation: 150,
                ghostClass: "blue-background-class",
                // },
                onEnd: function (evt) {
                    //拖拽结束发生该事件
                    vm.sort_table_val.splice(
                        evt.newIndex,
                        0,
                        vm.sort_table_val.splice(evt.oldIndex, 1)[0]
                    );
                    var newArray = vm.sort_table_val.slice(0);
                    vm.sort_table_val = [];
                    vm.$nextTick(function () {
                        vm.sort_table_val = newArray;
                    });
                },
            };
            //初始化
            var sortable = Sortable.create(el, ops);
        },
        sortTablePage() {
            var vm = this;
            this.sort_table_val = this.deepClone(this.sort_table_val_old); //fix 524
            this.dialogSortTable = true;
            this.$nextTick(() => {
                vm.srotTable();
            });
        },
        updateSort() {
            console.log(this.sort_table_val);
            var vm = this;
            var data = {
                workflowStatusList: [],
            };
            for (var i = 0; i < this.sort_table_val.length; i++) {
                var obj = {};
                obj.id = this.sort_table_val[i].id;
                var name = this.sort_table_val[i].statusType;
                obj.statusType = this.type_name_arr.indexOf(name);
                data.workflowStatusList.push(obj);
            }
            axios
                .post("/pmdm/admin/workflow/updateStatusList", data)
                .then(function (res) {
                    if (res.data.code == 200) {
                        console.log(res);
                        vm.$message({
                            type: "success",
                            message: res.data.message,
                        });
                        vm.dialogSortTable = false;
                        vm.loadTable();
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        updateSortClose() {
            this.dialogSortTable = false;
            this.sort_table_val = this.deepClone(this.sort_table_val_old);
            var vm = this;
            var el = this.$refs["example"];
            var sortTable = Sortable.create(el);
            sortTable.destroy(); //销毁排序
        },
    },
    created() {
        this.logoInfo();
        this.loadTable();
        (this.type_name_arr = [
            this.$t("message.workflowType.Pending"),
            this.$t("message.workflowType.Submit"),
            this.$t("message.workflowType.Review"),
            this.$t("message.workflowType.Released"),
            this.$t("message.workflowType.Complete"),
            this.$t("message.workflowType.Cancel"),
            this.$t("message.workflowType.Hold"),
        ]),
            (this.tableName = [
                this.$t("message.transform.choices"),
                this.$t("message.transform.selected"),
            ]),
            setTimeout(() => {
                this.loading = false;
                this.getAllNames();
            }, 500);
    },
    mounted() {
        document.body.ondrop = function (event) {
            event.preventDefault();
            event.stopPropagation();
        };
    },
};
</script>
  